














































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'ChangePassword' })
export default class extends SaascadaVue {

    dialog: boolean = false;
    password: string = '';
    verifyPassword: string = '';

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.password = '';
            this.verifyPassword = '';
        }
    }

    save() {
        this.dialog = false;
    }

    close() {
        this.dialog = false;
    }

};
